import styled from "@emotion/styled";

export const GeneratorButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
